/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Lms.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CompleteCourseResponse,
  CourseProgressResponse,
  ModuleProgressResponse,
  ProblemDetails
} from '../../../types/api';

import { apiClient } from '../../client/api-client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns overall course completion with module-level breakdown for the authenticated user
 * @summary Get user's progress for a course
 */
export const getCourseProgress = (
    courseId: string,
 signal?: AbortSignal
) => {


      return apiClient<CourseProgressResponse>(
      {url: `/api/learning/courses/${courseId}/progress`, method: 'GET', signal
    },
      );
    }




export const getGetCourseProgressQueryKey = (courseId: string,) => {
    return [
    `/api/learning/courses/${courseId}/progress`
    ] as const;
    }


export const getGetCourseProgressQueryOptions = <TData = Awaited<ReturnType<typeof getCourseProgress>>, TError = ProblemDetails>(courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseProgressQueryKey(courseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseProgress>>> = ({ signal }) => getCourseProgress(courseId, signal);





   return  { queryKey, queryFn, enabled: courseId !== null && courseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCourseProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseProgress>>>
export type GetCourseProgressQueryError = ProblemDetails


export function useGetCourseProgress<TData = Awaited<ReturnType<typeof getCourseProgress>>, TError = ProblemDetails>(
 courseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCourseProgress>>,
          TError,
          Awaited<ReturnType<typeof getCourseProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCourseProgress<TData = Awaited<ReturnType<typeof getCourseProgress>>, TError = ProblemDetails>(
 courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCourseProgress>>,
          TError,
          Awaited<ReturnType<typeof getCourseProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCourseProgress<TData = Awaited<ReturnType<typeof getCourseProgress>>, TError = ProblemDetails>(
 courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user's progress for a course
 */

export function useGetCourseProgress<TData = Awaited<ReturnType<typeof getCourseProgress>>, TError = ProblemDetails>(
 courseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourseProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCourseProgressQueryOptions(courseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Returns detailed module progress including scores, attempts, and SCORM data for the authenticated user
 * @summary Get user's progress for a module
 */
export const getModuleProgress = (
    courseId: string,
    moduleId: string,
 signal?: AbortSignal
) => {


      return apiClient<ModuleProgressResponse>(
      {url: `/api/learning/courses/${courseId}/modules/${moduleId}/progress`, method: 'GET', signal
    },
      );
    }




export const getGetModuleProgressQueryKey = (courseId: string,
    moduleId: string,) => {
    return [
    `/api/learning/courses/${courseId}/modules/${moduleId}/progress`
    ] as const;
    }


export const getGetModuleProgressQueryOptions = <TData = Awaited<ReturnType<typeof getModuleProgress>>, TError = ProblemDetails>(courseId: string,
    moduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModuleProgressQueryKey(courseId,moduleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModuleProgress>>> = ({ signal }) => getModuleProgress(courseId,moduleId, signal);





   return  { queryKey, queryFn, enabled: courseId !== null && courseId !== undefined && moduleId !== null && moduleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModuleProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModuleProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getModuleProgress>>>
export type GetModuleProgressQueryError = ProblemDetails


export function useGetModuleProgress<TData = Awaited<ReturnType<typeof getModuleProgress>>, TError = ProblemDetails>(
 courseId: string,
    moduleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModuleProgress>>,
          TError,
          Awaited<ReturnType<typeof getModuleProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModuleProgress<TData = Awaited<ReturnType<typeof getModuleProgress>>, TError = ProblemDetails>(
 courseId: string,
    moduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModuleProgress>>,
          TError,
          Awaited<ReturnType<typeof getModuleProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModuleProgress<TData = Awaited<ReturnType<typeof getModuleProgress>>, TError = ProblemDetails>(
 courseId: string,
    moduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user's progress for a module
 */

export function useGetModuleProgress<TData = Awaited<ReturnType<typeof getModuleProgress>>, TError = ProblemDetails>(
 courseId: string,
    moduleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModuleProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModuleProgressQueryOptions(courseId,moduleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Manually marks a course as complete when progress is 100%. Typically triggered automatically.
 * @summary Mark course as complete
 */
export const completeCourse = (
    courseId: string,
 signal?: AbortSignal
) => {


      return apiClient<CompleteCourseResponse>(
      {url: `/api/learning/courses/${courseId}/complete`, method: 'POST', signal
    },
      );
    }




export const getCompleteCourseMutationKey = () => ['completeCourse'] as const;

export const getCompleteCourseMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeCourse>>, TError,CompleteCourseMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeCourse>>, TError,CompleteCourseMutationVariables, TContext> => {

const mutationKey = getCompleteCourseMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeCourse>>, CompleteCourseMutationVariables> = (props) => {
          const {courseId} = props ?? {};

          return  completeCourse(courseId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteCourseMutationResult = NonNullable<Awaited<ReturnType<typeof completeCourse>>>

    export type CompleteCourseMutationError = ProblemDetails
    export type CompleteCourseMutationVariables = {courseId: string}

    /**
 * @summary Mark course as complete
 */
export const useCompleteCourse = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeCourse>>, TError,CompleteCourseMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeCourse>>,
        TError,
        CompleteCourseMutationVariables,
        TContext
      > => {
      return useMutation(getCompleteCourseMutationOptions(options), queryClient);
    }
